import { cn } from '@/lib/utils';

export interface AritoLocalTab {
  label: string;
}

interface AritoLocalTabsProps {
  tabs: AritoLocalTab[];
  value?: number;
  onValueChange?: (value: number) => void;
}

export function AritoLocalTabs({ tabs, value = 0, onValueChange }: AritoLocalTabsProps) {
  return (
    <div className='relative flex min-h-8 border-b-[3px] border-[#ddd]'>
      {tabs.map((tab, index) => {
        const selected = value === index;

        return (
          <button
            key={`${tab.label}-${index}`}
            type='button'
            className={cn(
              'relative min-h-8 min-w-20 whitespace-nowrap px-2 py-0.5 text-[0.7rem] font-black normal-case text-[#6b7280] transition-all duration-300 ease-in-out before:absolute before:bottom-[-3px] before:left-0 before:z-[2] before:h-[3px] before:w-full before:origin-left before:scale-x-0 before:bg-main before:transition-transform before:duration-300 before:ease-in-out hover:bg-main/10 hover:text-main hover:before:scale-x-100',
              selected && 'bg-main/10 text-main before:scale-x-100'
            )}
            onClick={() => onValueChange?.(index)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
